(function () {
    'use strict';

    // Get all 
    const socialfeedSliders = document.querySelectorAll('.mol-socialfeed');
    for (const socialfeedSlider of socialfeedSliders) {
        const swiperContainer = socialfeedSlider.querySelector('.swiper');

        new Swiper(swiperContainer, {
            slidesPerView: 1.1,
            spaceBetween: 16,
            watchOverflow: true,
            navigation: {
                nextEl: '.swiper-next',
                prevEl: '.swiper-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                type: 'bullets',
            },
            breakpoints: {
                640: {
                    slidesPerView: 1.7,
                },
                768: {
                    spaceBetween: 32,
                },
                1024: {
                    slidesPerView: 2.1,
                },
                1400: {
                    slidesPerView: 2.7,
                },
            },
            on: {
                afterInit: function () {
                    checkArrows(this);
                },
                resize: function () {
                    checkArrows(this);
                },
            },
        });
    }

    function checkArrows(swiper) {
        if (swiper.isBeginning && swiper.isEnd) {
            $(swiper.navigation.prevEl).addClass('hide-prevnext');
            $(swiper.navigation.nextEl).addClass('hide-prevnext');
        } else {
            $(swiper.navigation.prevEl).removeClass('hide-prevnext');
            $(swiper.navigation.nextEl).removeClass('hide-prevnext');
        }
    }
})();
